export default __webpack_public_path__ + "static/media/new-loader.db815074.gif";